module.exports = (theme) => ({
  ".grid-desktop-cols-3": {
    display: "grid",
    gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
    maxWidth: theme("screens.xl"),
    margin: "auto",
  },
  ".grid-desktop-cols-2": {
    display: "grid",
    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
    maxWidth: theme("screens.xl"),
    margin: "auto",
  },
  [`@media (max-width: ${theme("screens.lg")})`]: {
    ".grid-desktop-cols-2": { gridTemplateColumns: "1fr" },
    ".grid-desktop-cols-3": { gridTemplateColumns: "repeat(2, minmax(0, 1fr))" },
  },
  [`@media (max-width: ${theme("screens.sm")})`]: {
    ".grid-desktop-cols-3": { gridTemplateColumns: "1fr" },
  },
});
